import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "successCheckIcon",
  "use": "successCheckIcon-usage",
  "viewBox": "0 0 41.148 30.074",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 41.148 30.074\" id=\"successCheckIcon\"><path data-name=\"icon - checkmark\" d=\"M40.223 5.394l-23.75 23.75a3.135 3.135 0 0 1-4.465 0L.925 18.056a3.158 3.158 0 0 1 4.469-4.462l8.851 8.835L35.762.929a3.157 3.157 0 1 1 4.461 4.465z\" fill=\"#031425\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol